var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download-minimalistic-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.433,
    height: 13.776,
    viewBox: "0 0 20.433 13.776",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M12.628,16.634a.761.761,0,0,1-1.123,0L7.449,12.2a.761.761,0,0,1,1.123-1.026l2.734,2.991V8.179a.761.761,0,1,1,1.521,0v5.983l2.734-2.991A.761.761,0,0,1,16.685,12.2Z",
    transform: "translate(-1.85 -7.418)",
    fill: "#2197ed"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M3.822,15.011a.786.786,0,0,0-1.572,0v.056a26.914,26.914,0,0,0,.122,3.384A3.712,3.712,0,0,0,3.4,20.742a3.958,3.958,0,0,0,2.368,1,29.7,29.7,0,0,0,3.5.118h6.4a29.7,29.7,0,0,0,3.5-.118,3.958,3.958,0,0,0,2.368-1,3.712,3.712,0,0,0,1.029-2.292,26.931,26.931,0,0,0,.122-3.384v-.056a.786.786,0,0,0-1.572,0A26.386,26.386,0,0,1,21,18.247a2.25,2.25,0,0,1-.582,1.419,2.4,2.4,0,0,1-1.466.564,29.1,29.1,0,0,1-3.345.1H9.323a29.1,29.1,0,0,1-3.345-.1,2.4,2.4,0,0,1-1.466-.564,2.249,2.249,0,0,1-.582-1.419A26.369,26.369,0,0,1,3.822,15.011Z",
    transform: "translate(-2.25 -8.08)",
    fill: "#2197ed"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.58eb2ed7a838309db0bca1e9f05b148c.svg";
export { ForwardRef as ReactComponent };